<template>
	<div :class="classes">
		<div class="loading-inner">
			<div class="loading2-wrap" v-if="text !== ''">
				<div :class="['loading2', { 'loading2--ai': isAiStars }]" v-html="text" />
				<div class="ai-stars-stage" v-if="isAiStars" aria-hidden="true">
					<div class="ai-loader2-orbit">
						<span class="ai-loader2-icon"></span>
					</div>
					<span class="ai-loader-static" aria-hidden="true"> <span></span><span></span><span></span> </span>
				</div>
			</div>
			<div class="logo" v-if="showLogo"></div>
			<div class="loading3" v-if="!isAiStars"></div>
		</div>
	</div>
</template>

<script>
import { computed } from "vue";

export default {
	name: "LoadingSpinner",
	props: {
		animation: {
			type: String,
			default: "",
		},
		text: {
			type: String,
			default: "",
		},
		position: {
			type: String,
			default: "full",
		},
		nearTop: {
			type: Boolean,
			default: false,
		},
		mobileTextTop: {
			type: Boolean,
			default: false,
		},
		showLogo: {
			type: Boolean,
			default: false,
		},
		transparent: {
			type: Boolean,
			default: false,
		},
		noBackground: {
			type: Boolean,
			default: false,
		},
		solidBackground: {
			type: Boolean,
			default: false,
		},
	},
	setup(props) {
		const isAiStars = computed(() => props.animation === "ai-stars");

		const classes = computed(() => {
			let klasses = { loading: true };
			if (props.position !== "") {
				klasses[props.position] = true;
			}
			klasses.transparent = props.transparent;
			if (props.noBackground) klasses["no-background"] = true;
			if (props.nearTop) klasses["near-top"] = true;
			if (props.mobileTextTop) klasses["mobile-text-top"] = true;
			if (props.solidBackground) klasses["solid-background"] = true;
			return klasses;
		});

		return {
			classes,
			isAiStars,
		};
	},
};
</script>
<style lang="less" scoped>
@import "./../assets/css/less/_helper.less";
@import "./../assets/css/less/_settings.less";
.loading {
	.vertical-align-parent;
	z-index: 4;
	left: 0;
	top: 0;
	bottom: 0;
	right: 0;
	width: 100%;
	height: 100%;
	position: absolute;
	background-color: rgba(255, 255, 255, 0.95);

	&.no-background,
	&.transparent {
		background-color: transparent;
	}

	&.solid-background {
		background-color: #fff;
	}

	&.full {
		position: fixed;
		z-index: 999;
	}

	&.internal {
		position: relative;
		min-height: 34px;
	}

	&:not(.near-top) {
		.loading-inner {
			.vertical-align;
		}
	}

	&.near-top {
		.loading-inner {
			top: 10vh;
			position: sticky;
			padding-top: 10vh;
		}
	}

	.loading-inner {
		width: 100%;
		text-align: center;

		.logo {
			background: url(./../assets/img/partner-up-logo-brown2.svg) center center no-repeat;
			background-size: 140px auto;
			width: 140px;
			height: 40px;
			margin: 0 auto 5px;
		}

		.loading2-wrap {
			position: relative;
			display: inline-block;
			margin: 0 auto 6px;
			padding: 8px 34px;
		}

		.loading2 {
			text-align: center;
			margin: 0;
			font-size: 14px;
		}

		.loading2--ai {
			color: @formDefaultColour;
			font-weight: @bold;
		}
		.loading3 {
			background: url(./../assets/img/loader.svg) center center no-repeat;
			width: 60px;
			height: 30px;
			background-size: 100% auto;
			margin: 0 auto;
		}

		.ai-stars-stage {
			position: absolute;
			inset: -18px -22px;
			pointer-events: none;
		}

		.ai-loader2-orbit {
			position: absolute;
			left: 50%;
			top: 50%;
			width: 0;
			height: 0;
			transform: translate(-50%, -50%);
			transform-origin: center;
			animation: ai-loader2-orbit 2.4s linear infinite;
		}

		.ai-loader2-icon {
			display: block;
			width: 46px;
			height: 46px;
			transform: translate(-50%, -50%) translateX(56px);
			background: url(./../assets/img/loader2.svg) center center no-repeat;
			background-size: contain;
			filter: drop-shadow(0 10px 18px fade(@green, 16%));
		}

		.ai-loader-static {
			display: none;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			align-items: center;
			justify-content: center;
			gap: 6px;
			width: 40px;
			height: 16px;

			span {
				display: block;
				width: 8px;
				height: 8px;
				border-radius: @radiusCircle;
				background: fade(@green, 72%);
				box-shadow: 0 0 0 1px fade(#fff, 80%);
			}
		}

		p {
			color: @formDefaultColour;
			margin: 15px auto;
			text-align: center;
		}

		.lds-css {
			width: 110px;
			height: 110px;
			display: block;
			margin: 0 auto;
			overflow: hidden;

			.lds-spinner {
				position: relative;
				left: -45px;
				top: -45px;
				width: 200px !important;
				height: 200px !important;
				-webkit-transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
				transform: translate(-100px, -100px) scale(1) translate(100px, 100px);

				div {
					left: 94px;
					top: 48px;
					position: absolute;
					-webkit-animation: lds-spinner linear 1s infinite;
					animation: lds-spinner linear 1s infinite;
					background: @formDefaultColour;
					width: 12px;
					height: 24px;
					border-radius: 40%;
					-webkit-transform-origin: 6px 52px;
					transform-origin: 6px 52px;

					&:nth-child(1) {
						-webkit-transform: rotate(0deg);
						transform: rotate(0deg);
						-webkit-animation-delay: -0.916666666666667s;
						animation-delay: -0.916666666666667s;
					}

					&:nth-child(2) {
						-webkit-transform: rotate(30deg);
						transform: rotate(30deg);
						-webkit-animation-delay: -0.833333333333333s;
						animation-delay: -0.833333333333333s;
					}

					&:nth-child(3) {
						-webkit-transform: rotate(60deg);
						transform: rotate(60deg);
						-webkit-animation-delay: -0.75s;
						animation-delay: -0.75s;
					}

					&:nth-child(4) {
						-webkit-transform: rotate(90deg);
						transform: rotate(90deg);
						-webkit-animation-delay: -0.666666666666667s;
						animation-delay: -0.666666666666667s;
					}

					&:nth-child(5) {
						-webkit-transform: rotate(120deg);
						transform: rotate(120deg);
						-webkit-animation-delay: -0.583333333333333s;
						animation-delay: -0.583333333333333s;
					}

					&:nth-child(6) {
						-webkit-transform: rotate(150deg);
						transform: rotate(150deg);
						-webkit-animation-delay: -0.5s;
						animation-delay: -0.5s;
					}

					&:nth-child(7) {
						-webkit-transform: rotate(180deg);
						transform: rotate(180deg);
						-webkit-animation-delay: -0.416666666666667s;
						animation-delay: -0.416666666666667s;
					}

					&:nth-child(8) {
						-webkit-transform: rotate(210deg);
						transform: rotate(210deg);
						-webkit-animation-delay: -0.333333333333333s;
						animation-delay: -0.333333333333333s;
					}

					&:nth-child(9) {
						-webkit-transform: rotate(240deg);
						transform: rotate(240deg);
						-webkit-animation-delay: -0.25s;
						animation-delay: -0.25s;
					}

					&:nth-child(10) {
						-webkit-transform: rotate(270deg);
						transform: rotate(270deg);
						-webkit-animation-delay: -0.166666666666667s;
						animation-delay: -0.166666666666667s;
					}

					&:nth-child(11) {
						-webkit-transform: rotate(300deg);
						transform: rotate(300deg);
						-webkit-animation-delay: -0.083333333333333s;
						animation-delay: -0.083333333333333s;
					}

					&:nth-child(12) {
						-webkit-transform: rotate(330deg);
						transform: rotate(330deg);
						-webkit-animation-delay: 0s;
						animation-delay: 0s;
					}
				}
			}
		}
	}
}

@keyframes ai-loader2-orbit {
	0% {
		transform: translate(-50%, -50%) rotate(0deg);
	}
	100% {
		transform: translate(-50%, -50%) rotate(360deg);
	}
}

@media (prefers-reduced-motion: reduce) {
	.loading {
		.loading-inner {
			.ai-loader2-orbit {
				display: none;
				animation: none !important;
			}

			.ai-loader-static {
				display: inline-flex;
			}
		}
	}
}

@media (max-width: 1023px) {
	.loading.mobile-text-top {
		.loading-inner {
			position: absolute;
			top: 18px;
			box-sizing: border-box;
			padding: 0 16px;
			transform: none;
			-webkit-transform: none;
			-ms-transform: none;
		}
	}
}

@keyframes lds-spinner {
	0% {
		opacity: 1;
	}
	100% {
		opacity: 0;
	}
}
@-webkit-keyframes lds-spinner {
	0% {
		opacity: 1;
	}
	100% {
		opacity: 0;
	}
}
</style>
